import { useEffect, useState } from 'react'

/** The value, once it has stopped changing for `ms` — for a server count that follows typing. */
export function useDebounced<T>(value: T, ms = 400): T {
  const [settled, setSettled] = useState(value)
  useEffect(() => {
    const timer = window.setTimeout(() => setSettled(value), ms)
    return () => window.clearTimeout(timer)
  }, [value, ms])
  return settled
}
